export default __webpack_public_path__ + "static/media/face-2.46afde83.jpg";